// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as BsCss from "../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Button from "./Button.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as LayoutDataContext from "../../utils/LayoutDataContext.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Button$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/Button/Button.bs.js";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";

var clearIcon = Curry._1(BsCss.style, {
      hd: BsCss.color(BsCss.hex("395fa0")),
      tl: {
        hd: BsCss.fontSize(BsCss.px(14)),
        tl: {
          hd: BsCss.boxSizing("contentBox"),
          tl: {
            hd: BsCss.paddingTop(BsCss.px(3)),
            tl: /* [] */0
          }
        }
      }
    });

var resetButton = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.rem(3)),
      tl: {
        hd: BsCss.paddingRight(BsCss.rem(0.75)),
        tl: /* [] */0
      }
    });

var Styles = {
  clearIcon: clearIcon,
  resetButton: resetButton
};

function alphaNumbericSearch(str) {
  return str.replace(/[^\w\s]/g, "\\$&");
}

function SearchInput(props) {
  var trackSearchReset = props.trackSearchReset;
  var placeholder = props.placeholder;
  var defaultValue = props.defaultValue;
  var setSearch = props.setSearch;
  var match = React.useState(function () {
        return Belt_Option.getWithDefault(defaultValue, "");
      });
  var setSearchTerm = match[1];
  var searchTerm = match[0];
  var onSearchReset = function (param) {
    Curry._1(setSearchTerm, (function (param) {
            return "";
          }));
    Curry._1(setSearch, (function (param) {
            return "";
          }));
    Belt_Option.mapWithDefault(trackSearchReset, undefined, (function (track) {
            Curry._1(track, undefined);
          }));
  };
  var resetButton$1 = searchTerm.length > 0 ? JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
          children: JsxRuntime.jsx("button", {
                children: JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                      icon: [
                        "fas",
                        "times"
                      ],
                      className: clearIcon
                    }),
                className: "w-full h-full bg-transparent",
                onClick: onSearchReset
              }),
          variant: /* Icon */2,
          className: Cn.make([
                resetButton,
                "h-full absolute top-0 right-0"
              ])
        }) : null;
  var state = LayoutDataContext.useContext(undefined);
  var configurablePlaceholder = React.useMemo((function () {
          if (state !== undefined && state.searchBarPlaceholder.length > 0) {
            return state.searchBarPlaceholder;
          } else {
            return placeholder;
          }
        }), [
        Belt_Option.map(state, (function (c) {
                return c.searchBarPlaceholder;
              })),
        placeholder
      ]);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("img", {
                            className: "h-4 w-4 block mx-auto",
                            alt: "search",
                            src: "/images/search.svg"
                          }),
                      className: Cn.make([
                            Button.redCircleStyle,
                            "flex items-center content-center h-12 w-12 absolute left-0"
                          ])
                    }),
                JsxRuntime.jsx("input", {
                      className: "text-base bg-white h-12 pr-12 pl-16 lg:pl-16 sm:pl-16 outline-none focus:outline-none focus:shadow-sm border border-gray-300 shadow-md w-full rounded-full",
                      name: "search",
                      placeholder: Belt_Option.getWithDefault(configurablePlaceholder, "Search retailers"),
                      value: searchTerm,
                      onChange: (function (e) {
                          var value = e.target.value;
                          var cleanValue = alphaNumbericSearch(value);
                          Curry._1(setSearchTerm, (function (param) {
                                  return value;
                                }));
                          Curry._1(setSearch, (function (param) {
                                  return cleanValue;
                                }));
                        })
                    }),
                resetButton$1
              ],
              className: Belt_Option.getWithDefault(props.className, "")
            });
}

var make = SearchInput;

export {
  Styles ,
  alphaNumbericSearch ,
  make ,
}
/* clearIcon Not a pure module */
